module.exports = __webpack_public_path__ + "img/bg_1440_0_1016.3bb25964.jpg";